module.exports = __webpack_public_path__ + "images/tr_wework/ic-processing@1x-997394fc796376138ac1c3ecdf728488.png";